export enum PDPTemplates {
  CONVENTIONAL_LODGING = 'CONVENTIONAL_LODGING',
  SINGLE_UNIT_VR = 'SINGLE_UNIT_VR',
}
